import { Model } from 'pinia-orm';
import Role from './Role';

export default class Client extends Model {

    static get entity () {
        return 'permissions';
    }

    static fields () {
        return {
            id: this.uid(),
            action: this.attr(''),
            permissionable_id: this.attr(0),
            permissionable_type: this.attr('')
        }
    }
}
